import { GoogleGenAI } from "@google/genai";

// Helper to safely access environment variables in Vite/Browser environment
const getEnvVar = (key: string) => {
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    // @ts-ignore
    return import.meta.env[key] || import.meta.env[`VITE_${key}`];
  }
  return '';
};

const API_KEY = getEnvVar('API_KEY');

// Singleton instance logic
let ai: GoogleGenAI | null = null;

const getAiInstance = () => {
  if (!ai && API_KEY) {
    ai = new GoogleGenAI({ apiKey: API_KEY });
  }
  return ai;
};

export const getRegulatoryAdvice = async (prompt: string): Promise<string> => {
  // DEMO MODE: If no API Key is present, return a simulated response
  if (!API_KEY) {
    console.warn("Gemini API Key not found. Running in Demo Mode.");
    await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate network delay
    return `[DEMO MODE] \n\nI am currently running in demonstration mode because the API Key is not configured in the deployment environment.\n\nIf this were a live environment, I would analyze your query: "${prompt}" using Google's Gemini 2.5 Flash model to provide specific regulatory guidance.\n\nTo enable this feature, please add 'VITE_API_KEY' to your Cloudflare Pages environment variables.`;
  }

  try {
    const client = getAiInstance();
    if (!client) throw new Error("AI Client failed to initialize");
    
    const response = await client.models.generateContent({
      model: 'gemini-2.5-flash',
      contents: prompt,
      config: {
        systemInstruction: `You are RegulatorySherpa AI, a world-class expert in global pharmaceutical regulatory affairs (FDA, EMA, PMDA, etc.). 
        Your audience is biotech executives and regulatory professionals.
        Provide concise, accurate, and strategic advice. 
        If a user asks for legal advice, disclaim that you are an AI assistant and they should consult a professional.
        Structure your answers with clear headings and bullet points where appropriate.`,
        temperature: 0.7,
      }
    });

    return response.text || "I could not generate a response. Please try again.";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "An error occurred while contacting the Regulatory Intelligence AI. Please check your API key configuration.";
  }
};